import React from 'react';

interface AllDataIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const AllDataIcon: React.FC<AllDataIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M10 1.667c.407 0 .738.33.738.738v6.332l5.65-3.178a.738.738 0 0 1 .724 1.287L11.506 10l5.606 3.154a.738.738 0 1 1-.724 1.287l-5.65-3.179v6.333a.738.738 0 1 1-1.477 0v-6.332L3.61 14.44a.738.738 0 0 1-.725-1.287L8.493 10 2.886 6.846A.738.738 0 1 1 3.61 5.56l5.65 3.178V2.405c0-.408.332-.738.74-.738Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
